import React from 'react';

interface LoadingProps {
  blocking?: boolean;
  message?: string;
  children?: React.ReactNode;
  tag?: keyof JSX.IntrinsicElements;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  overlay?: boolean;
}

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  return (
    <div className={`animate-spin rounded-full border-4 border-gray-300 border-t-primary ${sizeClasses[size]} ${className}`} />
  );
};

const Loading: React.FC<LoadingProps> & {
  Spinner: React.FC<SpinnerProps>;
} = ({ 
  blocking = false, 
  message = "Loading, please wait", 
  children, 
  tag: Tag = 'div',
  className = '',
  size = 'md',
  overlay = true
}) => {
  if (!blocking) {
    return <Tag className={className}>{children}</Tag>;
  }

  return (
    <Tag className={`relative ${className}`}>
      {children}
      {overlay && (
        <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-50">
          <div className="flex flex-col items-center space-y-4">
            <Spinner size={size} />
            {message && (
              <p className="text-gray-600 text-sm font-medium">{message}</p>
            )}
          </div>
        </div>
      )}
    </Tag>
  );
};

// Standalone spinner component
Loading.Spinner = Spinner;

export default Loading;